import type { EnvironmentId } from "@cmmd-forge/contracts";

import { findCloudRowForEnvironment } from "~/routes/cloudRouteCatalogRow";
import type { CloudProjectCatalogRow } from "~/cmmd/cmmdForgeRuntimeListResource";
import type { CloudRuntimeProjectHandoff } from "../sidebar/cloudRuntimeProjectHandoffStore";

interface SavedRuntimeEnvironment {
  readonly environmentId: EnvironmentId;
  readonly runtimeId?: string;
}

/**
 * A saved-history route can retain CMMD's historical Environment key after the
 * files execution intent registers the live command connection under a newer
 * key. The runtime id is the stable link between both records.
 */
export function resolveProjectContentSearchConnectionEnvironment(input: {
  readonly environmentId: EnvironmentId;
  readonly catalogRows: readonly CloudProjectCatalogRow[];
  readonly handoffs: readonly CloudRuntimeProjectHandoff[];
  readonly savedEnvironments: readonly SavedRuntimeEnvironment[];
}): EnvironmentId {
  const runtimeId = findCloudRowForEnvironment(
    input.environmentId,
    input.catalogRows,
    input.handoffs,
  )?.runtimeId;
  if (!runtimeId) return input.environmentId;
  const matches = input.savedEnvironments.filter(
    (environment) => environment.runtimeId === runtimeId,
  );
  return matches.length === 1 ? matches[0]!.environmentId : input.environmentId;
}
